import React, { createContext, useEffect, useState } from 'react';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import UrlBase from "../urls/Urls.js";
import { useApp } from "../hooks/useApp";

const WebSocketContext = createContext();

const WebSocketProvider = ({ children }) => {
  const [notificationsWS, setNotificationsWS] = useState(null);
  const [statusMessageWS, setStatusMessageWS] = useState(null);
  const [clientState, setClientState] = useState(null);
  const [webSocketActive, setWebSocketActive] = useState(false);
  const [typingClientWS, setTypingClientWS] = useState(null);
  const [notificateClientWS, setNotificateClientWS] = useState([]);
  const websocketUrl = 'https://crm-websocket.bitcode-enterprise.com/bitcode-websocket';// UrlBase.websocket_url; // SockJS URL
  const topicMessage = '/topic/message';  // Topic to subscribe to
  const topicStatusMessage = '/topic/status-message';  // Topic to subscribe to
  const topicTyping = '/topic/typing';  // Topic to subscribe to
  const topicNotificate = '/topic/notificate';  // Topic to subscribe to
  const appEndpointMessage = '/app/endpoint';  // Endpoint to send messages
  const appEndpointTyping = '/app/endpoint-typing';  // Endpoint to send messages
  const appEndpointNotificate = '/app/endpoint-notificate';  // Endpoint to send messages

  const {authInfo} = useApp();

  const areArraysDifferent = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return true;
    return !arr1.every((value, index) => value === arr2[index]);
  };

  useEffect(() => {
    if(!authInfo)return;

    console.log('SockJS URL: ', websocketUrl);
    const client = new Client({
      webSocketFactory: () => new SockJS(websocketUrl),
      debug: (str) => console.log('WebSocket Debug: ', str), // Habilitar para probarlo localmente
      reconnectDelay: 5000,  // Reconnect every 5 seconds if disconnected
      onConnect: () => {
        setClientState(client);
        client.subscribe(topicMessage, (message) => {
          const notification = JSON.parse(message.body);
          setNotificationsWS(notification);
        });
        setClientState(client);
        client.subscribe(topicStatusMessage, (message) => {
          const notification = JSON.parse(message.body);
          setStatusMessageWS(notification);
        });
        client.subscribe(topicTyping, (message) => {
            const notification = JSON.parse(message.body);
            setTypingClientWS(notification);
        });
        client.subscribe(topicNotificate, (message) => {
            const notificationList = JSON.parse(message.body);
            let arrayAdd = [];
            let arrayRemove = [];
            notificationList.forEach((notification) => {
                if(notification.type === 'add'){
                    arrayAdd.push(notification.clientId);
                }else{
                    arrayRemove.push(notification.clientId);
                }
            });
            let list =[...notificateClientWS,...arrayAdd];
            let newList = list.filter((item) => !arrayRemove.includes(item));
            
            if(!areArraysDifferent(notificateClientWS, newList)){
                setNotificateClientWS(newList);
            }
        });
        setWebSocketActive(true);
      },
      onStompError: (frame) => {
        console.error('STOMP Error:', frame);
        setWebSocketActive(false);
      },
      onDisconnect: () => {
        setWebSocketActive(false);
      }
    });

    client.activate();  // Activate the connection

    return () => {
      client.deactivate();  // Clean up on unmount
    };
  }, [authInfo]);

  const sendMessageWS = (message) => {
    if (message && clientState) {
        clientState.publish({
        destination: appEndpointMessage,
        body: JSON.stringify(message),
      });
    }
  };

  const sendTypingWS = (message) => {
    if (message && clientState) {
        clientState.publish({
        destination: appEndpointTyping,
        body: JSON.stringify(message),
      });
    }
  };

  const sendNotificateWS = (message) => {
    if (message && clientState) {
        clientState.publish({
        destination: appEndpointNotificate,
        body: JSON.stringify(message),
      });
    }
  };

  return (
    <WebSocketContext.Provider value={{ 
        notificationsWS,
        statusMessageWS, 
        typingClientWS, 
        notificateClientWS, 
        sendMessageWS, 
        sendTypingWS, 
        sendNotificateWS,
        webSocketActive 
        }}>
      {children}
    </WebSocketContext.Provider>
  );
};


export { WebSocketContext, WebSocketProvider };